const _ = require("lodash");
const bookData = require("./data/dbBooks.json");
const PageShared = require("./PageShared");
const ElevShared = require("./ElevShared");
const {FLAGS} = require("./GlobalFlags");
const Big = require("big.js");

const getAvailableBooks = PageShared.getAvailableBooks;

const getAvailableBooksOfType = function(type) {
	const availBooks = getAvailableBookSKUs().map(getBookInfoFromSKU);
	return _.filter(availBooks, book => book.type === type);
};

const availableBookHashes = getAvailableBooks();

const isBookAvailable = function(bookHash) {
	return !!_.get(bookData, [bookHash, "isAvailable"]);
};

const isComboBook = function(bookHash) {
	return /^1/.test(bookHash);
};

const isPuzzleBook = PageShared.isPuzzleBook;

const isScienceBook = PageShared.isScienceBook;

const getPuzzleBookHashForGrade = function(grade) {
	return "puzzles" + grade;
};

const getPuzzleBookHashFromHash = function(bookHash) {
	const grade = getGradeFromHash(bookHash);
	return getPuzzleBookHashForGrade(grade);
};

const getPuzzleBookSKUFromHash = function(bookHash) {
	return getSKUs(["puzzle"], [bookHash], getGradeFromHash(bookHash));
};

const getAvailableScienceBooksForGrade = function(grade) {
	return availableBookHashes.filter(
		bookHash => bookHash.charAt(0) === grade && bookHash.charAt(2) === "S"
	);
};

const getAvailableBookRegex = PageShared.getAvailableBookRegex;

const getGradeFromHash = function(bookHash) {
	return isPuzzleBook(bookHash) ? bookHash.charAt(7) : bookHash.charAt(0);
};

const bookGrades = availableBookHashes.map(getGradeFromHash);

const availableGradeSets = PageShared.availableGradeSets;

const getAvailableGradeSets = function() {
	return availableGradeSets;
};

const doesGradeHaveSet = function(bookHashOrGrade) {
	const gChar = String(bookHashOrGrade).charAt(0);
	return _.includes(availableGradeSets, gChar);
};

const doesGradeHaveScience = function(bookHashOrGrade) {
	const gChar = String(bookHashOrGrade).charAt(0);
	return getAvailableScienceBooksForGrade(gChar).length > 0;
};

const doesGradeHaveScienceSet = function(bookHashOrGrade) {
	const gChar = String(bookHashOrGrade).charAt(0);
	return _.includes(availableGradeSets, gChar + "S");
};

const getAvailableGrades = function() {
	return ["1", "2", "3", "4", "5"].filter(g => _.includes(bookGrades, g));
};

const getAvailableLibraryGrades = function() {
	return FLAGS.accessUnfinishedGrades
		? getAvailableGrades()
		: getAvailableGradeSets();
};

const getAvailableGradeNumbers = function() {
	return getAvailableGrades().map(g => parseInt(g));
};

//Get all books in available grades even if single book is not yet available
const getBooksInAvailableGrades = function() {
	let books = [];
	getAvailableGrades().forEach(g => {
		books = books.concat(getGradeHashSequence(g));
	});
	return books;
};

const getGradeString = function(gradeChar) {
	const gradeNames = {
		"1": "First",
		"2": "Second",
		"3": "Third",
		"4": "Fourth",
		"5": "Fifth",
	};
	return gradeNames[gradeChar];
};

//Takes a string bookHash ("3B"), a string grade, or a numerical grade
//returns an ordered array of the bookhashes in that grade
const getGradeHashSequence = function(bookHashOrGrade, options = {}) {
	const gChar = isPuzzleBook(bookHashOrGrade)
		? bookHashOrGrade.charAt(7)
		: String(bookHashOrGrade).charAt(0);
	let books = [gChar + "A", gChar + "B", gChar + "C", gChar + "D"];
	if (!_.includes(options.excludeTypes, "puzzle")) {
		books.push("puzzles" + gChar);
	}
	if (
		!_.includes(options.excludeTypes, "science") &&
		doesGradeHaveScience(gChar)
	) {
		_.map(getAvailableScienceBooksForGrade(gChar), book => books.push(book));
	}
	if (options.excludeBooks && _.isArray(options.excludeBooks)) {
		books = _.without(books, ...options.excludeBooks);
	}
	return books;
};

const getAvailableBooksInGrade = function(grade, options) {
	return _.compact(
		getGradeHashSequence(grade, options).map(bookHash => {
			if (isBookAvailable(bookHash)) {
				return bookHash;
			}
			return null;
		})
	);
};

const isFirstInGrade = function(bookHash) {
	return /^[12345]A$/.test(bookHash);
};

//Return the previous book hash, or null if there is none
const getPreviousBookHash = function(bookHash, options = {}) {
	const hashPos = availableBookHashes.indexOf(bookHash);
	const prevBookHash = hashPos === 0 ? null : availableBookHashes[hashPos - 1];
	if (
		_.includes(options.excludeTypes, "puzzle") &&
		isPuzzleBook(prevBookHash)
	) {
		return getPreviousBookHash(prevBookHash, options);
	} else {
		return prevBookHash;
	}
};

//Return the previous book hash, or null if there is none
const getNextBookHash = function(bookHash, options = {}) {
	const hashPos = availableBookHashes.indexOf(bookHash);
	const nextBookHash =
		hashPos === availableBookHashes.length
			? null
			: availableBookHashes[hashPos + 1];
	if (
		_.includes(options.excludeTypes, "puzzle") &&
		isPuzzleBook(nextBookHash)
	) {
		return getNextBookHash(nextBookHash, options);
	} else {
		return nextBookHash;
	}
};

const getFullBookNameFromInfo = function(bookInfo) {
	return (
		"Beast Academy " + bookInfo.bookHash + " " + _.capitalize(bookInfo.type)
	);
};

const getSKUsForHashesAndTypes = function(bookHashes, bookTypes) {
	const skus = [];
	_.forEach(bookHashes, bookHash => {
		_.forEach(bookTypes, bookType => {
			const sku =
				_.get(bookData, [bookHash, "sku"]) ||
				_.get(bookData, [bookHash, bookType, "sku"]);
			if (sku) skus.push(sku);
		});
	});
	return skus;
};

const getSKUs = function(type, initialBookHash, grade) {
	const bookTypes = _.includes(["puzzle", "practice", "guide", "science"], type)
		? [type]
		: ["guide", "practice", "puzzle", "science"];
	let bookHashes = [initialBookHash];
	if (type === "grade-set") {
		bookHashes = _.filter(
			getGradeHashSequence(grade),
			h => !isPuzzleBook(h) && !isScienceBook(h)
		);
	} else if (type === "grade-set-science") {
		bookHashes = getGradeHashSequence(grade, {
			excludeTypes: ["puzzle", "guide", "practice"],
		});
	} else if (type === "grade-set-plus-puzzles") {
		bookHashes = getGradeHashSequence(grade); // why are we not excluding science here?
	}
	return getSKUsForHashesAndTypes(bookHashes, bookTypes);
};

const getAvailableBookSKUs = function(options = {}) {
	const typesToGet = _.difference(
		["guide", "practice", "puzzle", "science"],
		options.excludeTypes || []
	);
	return getSKUsForHashesAndTypes(availableBookHashes, typesToGet);
};

const getBookInfoFromSKU = function(sku) {
	return bookData.skuMap[sku];
};

function getGradeSetItems(grade, quantity, options) {
	options = options || {};

	const practiceItems =
		Number(grade) !== 1
			? [
					{sku: "beast-" + grade + "a-practice", quantity, options},
					{sku: "beast-" + grade + "b-practice", quantity, options},
					{sku: "beast-" + grade + "c-practice", quantity, options},
					{sku: "beast-" + grade + "d-practice", quantity, options},
			  ]
			: [];

	return [
		{sku: "beast-" + grade + "a", quantity, options},
		{sku: "beast-" + grade + "b", quantity, options},
		{sku: "beast-" + grade + "c", quantity, options},
		{sku: "beast-" + grade + "d", quantity, options},
		...practiceItems,
	];
}

function getScienceGradeSetItems(grade, quantity, options) {
	options = options || {};

	return [
		{sku: "beast-" + grade + "a-science", quantity, options},
		{sku: "beast-" + grade + "b-science", quantity, options},
	];
}

const getBookSetForGrade = function(grade) {
	// Book sets include all the books from a given grade
	// minus the puzzles book (if one exists)
	return getGradeSetItems(grade, 1, {});
};
const getScienceBooksForGrade = function(grade) {
	return getScienceGradeSetItems(grade, 1, {});
};
const getBooksInFullSetFromSKU = function(sku) {
	const grade = _.toNumber(_.last(sku));
	if (!grade || grade < 1 || grade > 5) {
		return [];
	}
	return sku.includes("science")
		? getScienceBooksForGrade(grade)
		: getBookSetForGrade(grade);
};

// the grade number will always be the 7th character in the first entry's SKU
// previous grades were determined via the index; this is not a good way to do it
// because we added "3S entries" to that array at an index of "5" - the values were hardcoded; this is not good - kab
const getGradeNumber = gradeSet => {
	return _.get(gradeSet, [0, "sku", 6], null);
};

const groupBooksIntoSets = function(bookItems, options = {}) {
	const allGradeSets = availableGradeSets
		// stop only at the math books
		.slice(0, 5)
		.map(getBookSetForGrade)
		.concat([getScienceBooksForGrade(3)])
		.concat([getScienceBooksForGrade(4)]);
	const nonBundleItems = _.filter(
		bookItems,
		item => !_.get(item, ["options", "bundleID"], null)
	);

	const copyOfItems = _.cloneDeep(nonBundleItems);
	const allFullSets = [];

	allGradeSets.forEach(gradeSet => {
		const allSKUs = gradeSet.map(book => book.sku);
		const gradeNumber = getGradeNumber(gradeSet);

		// Get the indices for all of the books in the set
		const allBookIndices = allSKUs.map(bookSKU =>
			_.findIndex(copyOfItems, item => item.sku === bookSKU)
		);

		// Check if all books in the set are science books
		const isScienceGradeSet = _.every(allSKUs, sku => sku.includes("science"));

		// If every index is not -1, then they have every book in their cart from this set
		// and we will take one each of the books and place them in a collection to the side
		// then we will save this full set to an object so we know what grades we have full
		// sets for, as well as the books in said full set
		// the copyOfItems array will have the quantity updated each time a book is removed
		// and books with a quantity of 0 are removed from the list of books after this
		if (_.every(allBookIndices, bookIndex => bookIndex !== -1)) {
			const bookQuantitiesInSet = allBookIndices.map(
				bookIndex => copyOfItems[bookIndex].quantity
			);
			const setQuantityToRemove = _.min(bookQuantitiesInSet);
			const thisFullSet = {
				subitems: [],
				sku: isScienceGradeSet
					? `full-set-science-${gradeNumber}`
					: `full-set-${gradeNumber}`,
				grade: gradeNumber,
				quantity: setQuantityToRemove,
				options: {},
			};

			allBookIndices.forEach(bookIndex => {
				const lineItem = _.cloneWith(copyOfItems[bookIndex], bookToClone => {
					const item = _.cloneDeep(bookToClone);
					item.quantity = setQuantityToRemove;
					item.totalQuantity = copyOfItems[bookIndex].quantity;
					if (item.price) {
						// Recompute prices to account for the fact that there may be
						// other copies of this book
						const itemSubtotalBig = Big(item.subtotal);
						const subtotalPerTotalQuantity = itemSubtotalBig.div(
							item.totalQuantity
						);
						const subtotalForThisQuantity = subtotalPerTotalQuantity.times(
							item.quantity
						);
						item.subtotal = subtotalForThisQuantity;
					}
					return item;
				});
				thisFullSet.subitems.push(lineItem);
				copyOfItems[bookIndex].totalQuantity = copyOfItems[bookIndex].quantity;
				copyOfItems[bookIndex].quantity =
					copyOfItems[bookIndex].quantity - setQuantityToRemove;
			});
			allFullSets.push(thisFullSet);
		}
	});
	_.remove(copyOfItems, item => item.quantity === 0);

	const res = _.concat(allFullSets, copyOfItems);
	return res;
};

const getBookCoverSrc = function(bookHash, isPractice, size) {
	let type = isPractice ? "practice" : "guide";
	if (!isBookAvailable(bookHash)) {
		type = "temp";
	}
	const extension =
		isPuzzleBook(bookHash) && size === "shadow" ? ".png" : ".jpg";
	const nameArray = isPuzzleBook(bookHash)
		? [bookHash, size]
		: [bookHash, type, size];
	const name = nameArray.join("-");
	return (global.BASE_URL || "/") + "assets/books/covers/" + name + extension;
};

const getBundleCovers = function(grade, type) {
	const typeString = type ? `-${type}` : "";
	return (
		global.BASE_URL +
		"assets/books/covers/bundle-" +
		grade +
		typeString +
		".png"
	);
};

const formatAddressFromData = function(data) {
	const lines = [];
	["name", "address1", "address2"].forEach(f => {
		if (data[f]) {
			lines.push(data[f]);
		}
	});
	lines.push([data.city, data.state].join(", ") + " " + data.zipcode);
	lines.push(data.country);
	return lines;
};

//Turns page data into a string format for display: p. 34-35
const getPageString = function(data) {
	let str = "";
	if (data.pages) {
		str += "p. " + data.pages.join(", ");
	} else if (data.pageFrom && data.pageTo) {
		str += "p. " + data.pageFrom + "-" + data.pageTo;
	}
	return str;
};

const getBookTopicsString = function(bookHash) {
	const topics = bookData[bookHash].topics;
	let str = topics.slice(0, topics.length - 1).join(", ");
	str += ", and " + _.last(topics);
	return str;
};

const getChapterNumbersByBookHash = function(bookHash) {
	const letter = _.toUpper(bookHash).substring(1);
	const map = {
		A: [1, 2, 3],
		B: [4, 5, 6],
		C: [7, 8, 9],
		D: [10, 11, 12],
	};
	return map[letter];
};

// Returns [grade, chapterNumber].
const getBookLastChapter = function(bookHash) {
	const bookGrade = parseInt(getGradeFromHash(bookHash));
	const lastChapter = _.last(getChapterNumbersByBookHash(bookHash));
	return [bookGrade, lastChapter];
};

const getPlanningDescriptors = function() {
	return ["Sequence", "Overviews", "Standards"];
};

const getAgeRangeByBookHash = function(bookHash) {
	const baLevel = getGradeFromHash(bookHash);
	return ElevShared.getAgeRangeByGrade(
		baLevel,
		isPuzzleBook(bookHash),
		isScienceBook(bookHash)
	);
};

module.exports = {
	getAvailableBooks,
	getAvailableBooksOfType,
	getAvailableBookRegex,
	getGradeSetItems,
	isComboBook,
	isPuzzleBook,
	isScienceBook,
	getPuzzleBookHashForGrade,
	getPuzzleBookHashFromHash,
	getPuzzleBookSKUFromHash,
	isBookAvailable,
	getGradeFromHash,
	getAgeRangeByGrade: ElevShared.getAgeRangeByGrade,
	getAvailableGradeSets,
	doesGradeHaveSet,
	doesGradeHaveScience,
	doesGradeHaveScienceSet,
	getAvailableGrades,
	getAvailableLibraryGrades,
	getAvailableGradeNumbers,
	getBooksInAvailableGrades,
	getGradeString,
	getGradeHashSequence,
	getAvailableBooksInGrade,
	isFirstInGrade,
	getPreviousBookHash,
	getNextBookHash,
	getFullBookNameFromInfo,
	getSKUs,
	getAvailableBookSKUs,
	groupBooksIntoSets,
	getBooksInFullSetFromSKU,
	getBookInfoFromSKU,
	getBookCoverSrc,
	getBundleCovers,
	formatAddressFromData,
	getPageString,
	getBookTopicsString,
	getChapterNumbersByBookHash,
	getBookLastChapter,
	getPlanningDescriptors,
	getAgeRangeByBookHash,
};
